import MerchantGradeApi from '@/api/merchant-grade'

const state = { }

const mutations = { }

const actions = {
  async listExaminees ({ commit }, params) {
    const result = await MerchantGradeApi.listExaminees(params)
    return result
  },
  async getExamineeById ({ commit }, id) {
    const result = await MerchantGradeApi.getExamineeById(id)
    return result
  },
  async addExaminee ({ commit }, data) {
    const result = await MerchantGradeApi.addExaminee(data)
    return result
  },
  async updateExaminee ({ commit }, data) {
    const result = await MerchantGradeApi.updateExaminee(data)
    return result
  },
  async uploadExaminees ({ commit }, forms) {
    const result = await MerchantGradeApi.uploadExaminees(forms)
    return result
  },
  async listProjects ({ commit }, params) {
    const result = await MerchantGradeApi.listProjects(params)
    return result
  },
  async allProjects ({ commit }) {
    const result = await MerchantGradeApi.allProjects()
    return result
  },
  async getProjectById ({ commit }, id) {
    const result = await MerchantGradeApi.getProjectById(id)
    return result
  },
  async addProject ({ commit }, data) {
    const result = await MerchantGradeApi.addProject(data)
    return result
  },
  async updateProject ({ commit }, data) {
    const result = await MerchantGradeApi.updateProject(data)
    return result
  },
  async listProjectLevels ({ commit }, projectId) {
    const result = await MerchantGradeApi.listProjectLevels(projectId)
    return result
  },
  async getProjectLevelById ({ commit }, params) {
    const result = await MerchantGradeApi.getProjectLevelById(params)
    return result
  },
  async addProjectLevel ({ commit }, data) {
    const result = await MerchantGradeApi.addProjectLevel(data)
    return result
  },
  async updateProjectLevel ({ commit }, data) {
    const result = await MerchantGradeApi.updateProjectLevel(data)
    return result
  },
  async listProjectExaminees ({ commit }, params) {
    const result = await MerchantGradeApi.listProjectExaminees(params)
    return result
  },
  async listProjectExamineesByExamineeId ({ commit }, examineeId) {
    const result = await MerchantGradeApi.listProjectExamineesByExamineeId(examineeId)
    return result
  },
  async submitExamineeProjectLevel ({ commit }, data) {
    const result = await MerchantGradeApi.submitExamineeProjectLevel(data)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-grade.js